document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const countryList = document.querySelector('#phone-country-list');
        const nlOption = document.querySelector('#phone-country-list li[value="NL"]');
        
        if (nlOption && countryList) {
            nlOption.click();
            countryList.click();
        }
    }, 1000);
});

document.addEventListener("BSS:openCartSlider", e => {
    const STYLE_ID = 'hide-checkout-style';
    if (!document.getElementById(STYLE_ID)) {
        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = `
            #CartDrawer-Checkout {
                opacity: 0.6;
                pointer-events: none !important;
            }
        `;
        document.head.appendChild(style);

        setTimeout(() => {
            const existingStyle = document.getElementById(STYLE_ID);
            if (existingStyle) {
                existingStyle.remove();
            }
        }, 2500);
    }
});

